import React, { useEffect, useState } from 'react';


import '../../styles/pacientesPendientes.css'
import '../../styles/tarjetaContenedor.css'

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';

const CredentialViewer = ({identificador,pacientesList}) => {

    const [isActive,setIsActive] = useState(false)
    const [isFound, setIsFound] = useState(false)
    const [paciente, setPaciente] = useState({})

    const [url,setUrl] = useState("")
    const [urlDos,setUrlDos] = useState("")
    const [isHover,setIsHover] = useState(false)
    const [isAnverso, setIsAnverso] = useState(true)
    //const [blobAnverso, setBlobAnverso] = useState("")
    //const [blobReverso, setBlobReverso] = useState("")

    const [isLoader,setIsLoader] = useState(false)

useEffect(()=>{
    setIsActive(false)
    setIsFound(false)
    setIsLoader(true)
    if(identificador){
        for(let i=0;i<pacientesList.length;i++){
            if(identificador.toUpperCase()===pacientesList[i].identificador){
                setIsFound(true)
                if(pacientesList[i].active){
                    setIsActive(true)
                }
                else{
                    setIsActive(false)
                }
                setPaciente(pacientesList[i])
                return
            }
        }
    }
    else{
        setIsFound(false)
        setIsActive(false)
        setIsLoader(false)
        setPaciente({})
    }
},[identificador,pacientesList])

useEffect(()=>{
    if(paciente.identificador){
        if(paciente.active){
            let jsonFront = {
                apikey : process.env.REACT_APP_KEY,
                Specialist : paciente.specialty.toUpperCase(),
                Tenant : paciente.hospital,
                ID : paciente.identificador
              }
            
              fetch(process.env.REACT_APP_BADGE_VALID_FRONT,
              {
                  method: "POST",
                  mode: "cors",
                  body: JSON.stringify(jsonFront)
              })
              .then(function(response) {
                  if(response.ok) {
                    response.blob().then(function(miBlob) {
                      //setBlobAnverso(miBlob)
                      var objectURL = URL.createObjectURL(miBlob);
                      setUrl(objectURL)
                      setTimeout(() => {
                        setIsLoader(false)
                      }, "1000");
                    });
                  } else {
                    //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                  }
                })
                .catch(function(error) {
                  //console.log('Hubo un problema con la petición Fetch:' + error.message);
                });


            let jsonBack = {
                "apikey":process.env.REACT_APP_KEY,  
                "Specialist1":paciente.specialty_array[0], 
                "Specialist1ID":paciente.cedula_array[0],
                "Specialist2":paciente.specialty_array[1],
                "Specialist2ID":paciente.cedula_array[1],
                "Specialist3":paciente.specialty_array[2],
                "Specialist3ID":paciente.cedula_array[2]
                }

                fetch(process.env.REACT_APP_BADGE_VALID_BACK,
                {
                    method: "POST",
                    mode: "cors",
                    body: JSON.stringify(jsonBack)
                })
                .then(function(response) {
                    if(response.ok) {
                      response.blob().then(function(miBlob) {
                        //setBlobReverso(miBlob)
                        var objectURL = URL.createObjectURL(miBlob);
                        setUrlDos(objectURL)
                        
                      });
                    } else {
                      //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                    }
                  })
                  .catch(function(error) {
                    //console.log('Hubo un problema con la petición Fetch:' + error.message);
                  });
            
        }
        else{
            let jsonFront = {
                apikey : process.env.REACT_APP_KEY,
                Specialist : paciente.specialty.toUpperCase(),
                Tenant : paciente.hospital,
                ID : paciente.identificador
              }
            
              fetch(process.env.REACT_APP_BADGE_VOIDED_FRONT,
              {
                  method: "POST",
                  mode: "cors",
                  body: JSON.stringify(jsonFront)
              })
              .then(function(response) {
                  if(response.ok) {
                    response.blob().then(function(miBlob) {
                      //setBlobAnverso(miBlob)
                      var objectURL = URL.createObjectURL(miBlob);
                      setUrl(objectURL)
                      setTimeout(() => {
                        setIsLoader(false)
                      }, "1000");
                    });
                  } else {
                    //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                  }
                })
                .catch(function(error) {
                  //console.log('Hubo un problema con la petición Fetch:' + error.message);
                });


            let jsonBack = {
                "apikey":process.env.REACT_APP_KEY,  
                "Specialist1":paciente.specialty_array[0], 
                "Specialist1ID":paciente.cedula_array[0],
                "Specialist2":paciente.specialty_array[1],
                "Specialist2ID":paciente.cedula_array[1],
                "Specialist3":paciente.specialty_array[2],
                "Specialist3ID":paciente.cedula_array[2]
                }

                fetch(process.env.REACT_APP_BADGE_VOIDED_BACK,
                {
                    method: "POST",
                    mode: "cors",
                    body: JSON.stringify(jsonBack)
                })
                .then(function(response) {
                    if(response.ok) {
                      response.blob().then(function(miBlob) {
                        //setBlobReverso(miBlob)
                        var objectURL = URL.createObjectURL(miBlob);
                        setUrlDos(objectURL)
                        
                      });
                    } else {
                      //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                    }
                  })
                  .catch(function(error) {
                    //console.log('Hubo un problema con la petición Fetch:' + error.message);
                  });
        }
    }
},[paciente])

const handleMostrar = () => (event) => {
    event.preventDefault()
    setIsHover(true)
    //setTimeout(() => btn.classList.add('animate'), 100)
    setTimeout(() => {
        setIsAnverso(!isAnverso)
        setIsHover(false)
      }, "1000");
}


    return(
        <>
        <section className='seccion_pacientes_pendientes'>
            <div id="cuerpoEncabezado" className='cuerpoEncabezado'>
                <EncabezadoSeccion tituloInicial={"Credencial"} tituloFinal={identificador} imgSource={"https://hospitalesmac.com/img/icono_16.png"}/>
            </div>
            <div className='itemservespCont'>
                <div className={"itemCredential"}>
                    <br></br>
                    <br></br>
                    {
                        isFound
                            ?
                                isActive
                                ?
                                    <>
                                        {
                                            !isLoader
                                                ?
                                                    <>
                                                        <span className="activeCredential">Activo</span>
                                                        {
                                                            !isHover 
                                                                ?
                                                                    isAnverso
                                                                        ?
                                                                            <img src={url} width={"321.25988299px"} height={"209.76380595px"} className='credentialView'  
                                                                                onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                        :
                                                                            <img src={urlDos} width={"321.25988299px"} height={"209.76380595px"} className='credentialView' onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                :
                                                                    isAnverso
                                                                        ?
                                                                            <img src={url} width={"321.25988299px"} height={"209.76380595px"} className='credentialViewHover'  onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                        :
                                                                            <img src={urlDos} width={"321.25988299px"} height={"209.76380595px"} className='credentialViewHover'  onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                    
                                                        }
                                                    </>
                                                :
                                                <>
                                                    <h1 className='itemblogTitle'>{"Cargando Credencial"}</h1>      
                                                        <img src={"https://hospitalesmac.com/img/logo.png"} width={"107.25988299px"} height={"69.76380595px"} className='credentialView' alt={paciente.identificador +" "+paciente.name}/>
                                                    </>
                                        }
                                    </>
                                :
                                    <>
                                        {
                                            !isLoader
                                                ?
                                                    <>
                                                        <span className="inactiveCredential">Inactivo</span>
                                                        {
                                                            !isHover 
                                                                ?
                                                                    isAnverso
                                                                        ?
                                                                            <img src={url} width={"321.25988299px"} height={"209.76380595px"} className='credentialView'  
                                                                                onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                        :
                                                                            <img src={urlDos} width={"321.25988299px"} height={"209.76380595px"} className='credentialView' onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                :
                                                                    isAnverso
                                                                        ?
                                                                            <img src={url} width={"321.25988299px"} height={"209.76380595px"} className='credentialViewHover'  onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                        :
                                                                            <img src={urlDos} width={"321.25988299px"} height={"209.76380595px"} className='credentialViewHover'  onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                                    
                                                        }
                                                    </>
                                                :
                                                    <>
                                                        <h1 className='itemblogTitle'>{"Cargando Credencial"}</h1>      
                                                        <img src={"https://hospitalesmac.com/img/logo.png"} width={"107.25988299px"} height={"69.76380595px"} className='credentialView' alt={paciente.identificador +" "+paciente.name}/>
                                                    </>
                                        }
                                        
                                    </>
                            :
                                <span className="inactiveCredential">Sin información</span>
                    }
                </div>
            </div>
        </section>
        </>
    )
}

export default CredentialViewer;